import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import { COLUMN_WIDTH_100 } from '@modules/page-builder/config/column-constants';

export const PADDING_TOP_BOTTOM_SECTION = 120;
export const PADDING_LEFT_RIGHT_SECTION = 32;
export const PADDING_LEFT_RIGHT_SECTION_MOBILE = 18;
export const MODAL_BOX_SHADOW = `0px 14px 24px 2px rgba(0, 0, 0, 0.08)`;

export const PADDING_TOP_CAPTION_MOBILE = 16;

export const SingleImageContainer: StyleRule = ({
    theme,
    moduleType,
    isProjectRevamp,
}) => ({
    width: '100%',
    margin: '0 auto',
    [theme.screen.laptop]: {
        height: 'auto',
        width:
            moduleType === 'MediumSingleImageModule'
                ? '65% !important' // Medium image is roughly 65% of the width of largeimages
                : pxToRem(COLUMN_WIDTH_100),

        // Project detail revamp (BC-4725): the large single image spans the
        // full content width, so drop the legacy 1820px cap.
        ...(isProjectRevamp && {
            width: '100%',
        }),
    },
});

export const FullPageImageContainer: StyleRule = ({ theme }) => ({
    width: '100%',
    margin: '0 auto',

    [theme.screen.laptop]: {
        padding: '0',
        margin: '0',
        width: '100%',
    },
});
